<template>
    <b-container>
        <b-row>
            <b-col offset="3" cols="6">
                <railway-add-form v-if="store.state[STORE_MODULE_NAME].elementInEdit == null"></railway-add-form>
                <railway-update-form v-else="store.state[STORE_MODULE_NAME].elementInEdit != null"></railway-update-form>
            </b-col>
        </b-row>
    </b-container>
</template>


<script>


    import store from '@/store'

    import RailwayAddForm from './forms/add/representations/WizardForm'
    import RailwayUpdateForm from './forms/update/representations/WizardForm'

    import {BContainer, BRow, BCol} from 'bootstrap-vue'

    import { STORE_MODULE_NAME } from '../railwayStoreModule'

    export default {


        setup() {

            return {
                store,
                STORE_MODULE_NAME,
            }
        },

        components:{

            BContainer, BRow, BCol,
            RailwayAddForm,
            RailwayUpdateForm
        },

    }
</script>
